import { handleResponse } from '../../utils/handle-response';
import * as apiHelper from '../../utils/apiHelper';

export function uploadExcel(file) {
    var data = new FormData();
    data.append('file', file, file.name);
    const requestOptions = {
        method: 'POST',
        body: data
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_UPLOADEXCEL);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function convertSelected(selectedRows, userId) {
    console.log(selectedRows, userId)
   const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },
    
        body: JSON.stringify({registrations: selectedRows, userId: userId})};

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CONVERT2EXCELNODERED);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function deleteTransformedExcel(id) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_DELETETRANSFORMEDEXCEL);
    url += `?id=${id}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });

}

export function getAllProcessedExcelFiles(userId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETPROCESSEDEXCELFILES);
    url += `?userId=${userId}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}


export function getRegistrations(userId) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_GETFILEDATA);
    url += `?userId=${userId}`;
    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

export function createMapping() {

    const requestOptions = {
        method: 'POST', headers: {
            'Content-Type': 'application/json',
        },       
    };

    let url = apiHelper.ComposeUri(apiHelper.API_ACTION_CREATEMAPPING);

    return fetch(url, requestOptions)
        .then(handleResponse)
        .catch(() => {
            return null;
        });
}

